import React from 'react';

import { useFormContext } from 'react-hook-form';
import { observer } from 'mobx-react';

import { LbRadioGroup } from '@infoods/lifebase-ui';
import {
  RangeInput,
  MultipleComboBox,
  HiddenInput,
} from '../../../../../../../components/form-components';
import { CustomFilterFormValues } from '../../AddCustomFilterForm.settings';
import { customFilterStore } from '../../../../../stores/customFilterStore';
import { UserGroupFilter } from './UserGroupFilter/UserGroupFilter';
import { AffiliateGroupFilter } from './AffiliateGroupFilter/AffiliateGroupFilter';
import { genderOptionsWithAll } from '../../../../../../../constants/user-info/gender';
import { ModalInputBox, ModalInputGroup } from '../../../../../../../components/modals';
import { workoutOptions } from '../../../../../../../constants/user-info/workout';
import { loggedInUserDataStore } from '../../../../../../../stores/loggedInUserDataStore';
import { SchoolGroupFilter } from './SchoolGroupFilter/SchoolGroupFilter';

const PersonalInfo = observer(() => {
  const { selectedResourceType } = customFilterStore;
  const { paymentFlowType, isSuperAdmin } = loggedInUserDataStore;
  const { CUSTOMERS, SCHOLASTIC } = selectedResourceType;
  const { control, register } = useFormContext<CustomFilterFormValues>();

  const showSchoolGroupFilter =
    (isSuperAdmin && selectedResourceType.CUSTOMERS) ||
    paymentFlowType.NEW_USER_FLOW_2024;

  return (
    <ModalInputBox title="Personal Info">
      <HiddenInput
        register={register}
        name="filters.PERSONAL_INFO.filterType"
        value="PERSONAL_INFO"
      />
      <ModalInputGroup>
        <LbRadioGroup
          row
          control={control}
          label="Gender"
          name="filters.PERSONAL_INFO.genderType"
          options={genderOptionsWithAll}
          defaultValue=""
        />
        <RangeInput
          control={control}
          startProps={{ name: 'filters.PERSONAL_INFO.age.from' }}
          endProps={{ name: 'filters.PERSONAL_INFO.age.to' }}
          min={12}
          max={95}
        />
      </ModalInputGroup>
      {showSchoolGroupFilter && <SchoolGroupFilter />}
      {CUSTOMERS && <UserGroupFilter />}
      {SCHOLASTIC && <AffiliateGroupFilter />}
      <MultipleComboBox
        control={control}
        size="small"
        variant="outlined"
        name="filters.PERSONAL_INFO.workoutTypes"
        label="Workout Type"
        options={workoutOptions}
        limitTags={3}
      />
    </ModalInputBox>
  );
});

export { PersonalInfo };
